const DownloadIconDisabled = ({ colour = '#CBCBCB', width = '15', height = '15' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" id="download-icon-disabled">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 0C3.143 0 0 3.143 0 7C0 10.857 3.143 14 7 14C10.857 14 14 10.857 14 7C14 3.143 10.857 0 7 0ZM6.29999 5.59973V3.49973C6.29999 3.11473 6.61499 2.79973 6.99999 2.79973C7.38499 2.79973 7.69999 3.11473 7.69999 3.49973V5.59973H8.95299C9.26799 5.59973 9.42199 5.97773 9.19799 6.19473L7.24499 8.14773C7.10499 8.28773 6.88799 8.28773 6.74799 8.14773L4.79499 6.19473C4.57799 5.97773 4.73199 5.59973 5.04699 5.59973H6.29999ZM9.80005 10.4999H4.20005C3.81505 10.4999 3.50005 10.1849 3.50005 9.79989C3.50005 9.41489 3.81505 9.09989 4.20005 9.09989H9.80005C10.185 9.09989 10.5 9.41489 10.5 9.79989C10.5 10.1849 10.185 10.4999 9.80005 10.4999Z"
                fill={colour}
            />
        </svg>
    );
};

export default DownloadIconDisabled;
